var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleGmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.014 72H34.396V49.3361L21 39.3487V68.0452C21 70.2328 22.8149 72 25.014 72Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5992 72H75.9812C78.2235 72 79.9952 70.1945 79.9952 68.007V39.3487L66.5992 49.3361V72Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5992 32.0122V49.3361L80 39.3487V34.0087C80 29.0556 74.3247 26.2471 70.3444 29.2084L66.5992 32.0122Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.396 49.3361V32.0122L50.5 44.0343L66.5992 32.0122V49.3361L50.5 61.32L34.396 49.3361Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 34.0093V39.3493L34.4008 49.3367V32.0128L30.6557 29.2091C26.6753 26.2525 21 29.0944 21 34.0093Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 44,
    fill: "white",
    transform: "translate(21 28)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleGmail);
export default __webpack_public_path__ + "static/media/GoogleGmail.4f39053879a6c21461b67927c5d22f3c.svg";
export { ForwardRef as ReactComponent };